import Vue from 'vue'
import Router from 'vue-router'
import shouye from '@/router/shouye'
import market_data from '@/router/market_data'

import tTai from '@/router/tTai'


import zhanhui from '@/router/zhanhui'

import streetPat from '@/router/streetPat'

import maggzine from '@/router/maggzine'

import paihang from '@/router/paihang'
import shoeMaterial from '@/router/shoeMaterial'
import video from '@/router/video'
import jubuDetail from '@/router/jubuDetail'
import inter898 from '@/router/inter898'
import my from '@/router/my'
import qushi from '@/router/qushi'
import dinghuo from '@/router/dinghuo'
import dapai from '@/router/dapai'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
}

export default new Router({
    // mode: 'history',
    linkActiveClass: "active",
    routes: [
        ...shouye,
        ...market_data,
        ...zhanhui,
        ...tTai,
        ...streetPat,
        ...maggzine,
        ...paihang,
        ...shoeMaterial,
        ...video,
        ...jubuDetail,
        ...inter898,
        ...my,
        ...qushi,
        ...dinghuo,
        ...dapai,

        // 商品详情
        {
            path: '/kinds_detail',
            name: 'kinds_detail',
            component: () => import('@/views/kinds_detail')
        },
      {//女鞋详情
        path: '/womensShoes/detail',
        name: 'womens_shoes_detail',
        component: () => import('@/views/womensShoes/detail')
      },
        // 趋势详情
        {
            path: '/qushiDetail',
            name: 'qushiDetail',
            component: () => import('@/views/qushiDetail')
        },
      {
        path: '/qushiDetailNews',
        name: 'qushiDetailNews',
        component: () => import('@/views/qushiDetailNews')
      },
        {
            path: '/pTdetail',
            name: 'pTdetail',
            component: () => import('@/views/pTdetail')
        },
        // 男鞋
        {
            path: '/man',
            name: 'man',
            component: () => import('@/views/man')
        },

        // 市场实拍
        {
            path: '/goodsList',
            name: 'goodsList',
            component: () => import('@/views/goodsList'),
            meta: {

                keepAlive: true, //此组件需要被缓存
                isBack: false,

            },
        },
        // 男鞋
        {
            path: '/goodsList-man',
            name: 'goodsList-man',
            component: () => import('@/views/goodsList-man'),
            meta: {

                keepAlive: true, //此组件需要被缓存
                isBack: false,

            },
        },
        // 童鞋
        {
            path: '/goodsList-child',
            name: '/goodsList-child',
            component: () => import('@/views//goodsList-child'),
            meta: {

                keepAlive: true, //此组件需要被缓存
                isBack: false,

            },
        },

        // 登录
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/login')
        },
        // 招聘
        {
            path: '/job/job-list',
            name: 'joblist',
            component: () => import('@/views/job/job-list')
        },
        {
            path:'/searchList',
            name:'searchList',
            component:() => import('@/views/searchList')
        },
    ]
})




// WEBPACK FOOTER //
// ./src/router/index.js